<atlas-navbar [demo]="demo" [token]="token" [serviceProviderId]="serviceProviderId" [partnerId]="partnerId"
    [accountId]="accountId" [marketId]="marketId" [groupPath]="brandPath" [dropdownItems]="dropdownItems$ | async"
    [hideCenters]="hideCenters" [hideNotifications]="hideNotifications" [disableUserDropdown]="disableUserDropdown" (event)="propagateEvent($event)"
    [showLanguageSelector]="showLanguageSelector">
    <div class="business-navbar__atlas-injection">
        <atlas-item *ngIf="showMenuHamburger$ | async" interactable icon="store"
            iconText="{{ menuText$ | async }}" customClass="atlas-navbar__menu-toggle" (click)="toggleMenu()">
        </atlas-item>
        <atlas-location-selector class="business-navbar__location-selector"></atlas-location-selector>
    </div>
</atlas-navbar>
<div #inject>
    <ng-content></ng-content>
</div>
